import React, { useEffect, useState, useDeferredValue } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AuthService from "../services/auth.service";
import Helpers from '../services/helpers';
import { Modal } from "react-bootstrap";
import Logo from '../assets/images/Logo.png'
import Nocheck from '../assets/images/nocheck.png'
import Yescheck from '../assets/images/yescheck.png'
import { useDispatch, useSelector } from 'react-redux';
import { fetchWallet } from '../app/slice/walletSlice';
import { getCurrency } from '../app/slice/currencySlice';
import { AppDispatch, RootState } from '../app/store';
import Bitcoin from '../assets/images/bitcoinHead.png'

function Header() {
  const walletAmount = useSelector((state: RootState) => state.wallet.wallet);
  const currencyTypesList = useSelector((state: RootState) => state.currency.currency);

  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  let pageName = splitLocation[1];

  const Token = Helpers.getTokenData();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [wallet, setWallet] = useState<any | Number>(walletAmount);
  const [currencyList, setCurrencyList] = useState(currencyTypesList);
  const [message, setMessage] = useState("");
  const [scrolled, setScrolled] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [searchCurrency, setSearchCurrency] = useState('');
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();


  useEffect(() => {
    if (Token?.access_token) {
      dispatch(fetchWallet());
      dispatch(getCurrency());
    }
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    setWallet(walletAmount);
  }, [walletAmount]);

  useEffect(() => {
    setCurrencyList(currencyTypesList);
  }, [currencyTypesList]);

  useEffect(() => {
    const handleScroll = () => {
      // If the window is scrolled more than 50px
      if (window.scrollY > 10) {
        // Delay adding the class by 2 seconds
        setTimeout(() => {
          setScrolled(true); // Add class after 2 seconds
        },);
      } else {
        setScrolled(false); // Remove class if at the top
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  // Handle the click event on the form-check div
  const handleClickCurrency = (index: number, currency: string) => {
    setSelectedIndex(index);
    alert(currency);
    setSearchCurrency('');
    setSelectedIndex(null);
    setShowCurrency(false);
  };


  useEffect(() => {
    // Get the current date
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    setCurrentDate(formattedDate); // Set the default value
  }, []);

  const [currentDate, setCurrentDate] = useState<string>('');

  const [showCurrency, setShowCurrency] = useState(false);

  const handleCloseCurrency = () => {
    setShowCurrency(false);
    setSearchCurrency('');
    setSelectedIndex(null);
  }
  const handleShowCurrency = () => setShowCurrency(true);

  const [showfilter, setFilter] = useState(false);

  const handleCloseFilter = () => setFilter(false);
  const handleShowFilter = () => setFilter(true);


  /*
    function getWallet() {
      AuthService.wallet()
        .then(
          (response) => {
            // console.log(response.data);
            if (response.status === 200) {
              setWallet(response?.data);
            } else {
              setMessage(response?.message);
            }
          }
        ).catch((error) => {
          const message = error?.response?.data?.error_description;
          setMessage(message);
          if (error?.response?.data?.status === 401) {
            localStorage.removeItem("w_token");
            navigate('/login');
          }
        }).finally(() => {
          //setIsPageLoading(false);
        });
  
    }
  */

  /*
  function getCurrencyList() {
    AuthService.currency()
      .then(
        (response) => {
          // console.log(response.data);
          if (response.status === 200) {
            setCurrencyList(response?.data);
          } else {
            setMessage(response?.message);
          }
        }
      ).catch((error) => {
        const message = error?.response?.data?.error_description;
        setMessage(message);
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem("w_token");
          navigate('/login');
        }
      }).finally(() => {
        //setIsPageLoading(false);
      });
  }
*/
  function handleSearchCurrency(event: React.ChangeEvent<HTMLInputElement>) {
    setSearchCurrency(event.target.value);
  }

  return (
    <>
      <style>
        {`
        .selectCurrency.modal.fade .modal-dialog {
            transition: transform .3s ease-out;
          transform: translate(0%,100%) !important;
          }
          .selectCurrency.modal.show .modal-dialog{
            transform: none !important;
          }
          @media screen and (min-width: 1024px) {
            .selectCurrency.modal.fade .modal-dialog {
              transition: transform .3s ease-out;
              transform: translate( 100%,0%) !important;
            }
            .selectCurrency.modal.show .modal-dialog{
              transform: none !important;
            }
          }
        `}
      </style>

      <section className={`Navbar ${scrolled ? 'sticky' : 'stickyNone'}`}>
        <div className="container position-relative">
          <div className="row">
            <div className="col-12 p-0">
              <nav className='d-flex justify-content-between p-0 align-items-center
'>
                <Link to='/' state={{ textDecoration: 'none' }}>
                  <img src={Logo} alt="Logo" className='img-fluid' />
                </Link>

                {!Token?.access_token ?
                  (
                    pageName === 'login' || pageName === 'register' ?
                      (
                        <div>
                          <Link to='/' style={{ opacity: 0.4, textDecoration: 'underline', color: '#fff' }}>
                            <svg height='22' width='22' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff"><path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                            </svg>
                          </Link>
                        </div>
                      ) :
                      (
                        <div>
                          <Link to='/register'>
                            <button className='register'>Register</button>
                          </Link>
                          <Link to='/login'>
                            <button className='login'>Login</button>
                          </Link>
                        </div>
                      )
                  ) :
                  (
                    <div className='d-flex'>
                      <div className='Balance'>
                        <h6 className='align-items-center d-flex' onClick={handleShowCurrency}>
                          <img src={Bitcoin} alt="" className='img-fluid curinceImg' />
                          {wallet?.user_combined_wallet}
                          <svg className='ms-2' xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                            <path d="M7.00063 5.1714L11.9504 0.22168L13.3646 1.63589L7.00063 7.9999L0.636719 1.63589L2.05093 0.22168L7.00063 5.1714Z" fill="white" />
                          </svg>
                        </h6>
                        <div className='depWit depWitWeb'>
                          <Link to="/deposit">
                            <button className='align-items-center d-flex'>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
                                <path d="M8.07586 0.876484L6.24426 5.14008H4.41266C4.10866 5.14008 3.81226 5.16288 3.52346 5.22368L4.28346 3.39968L4.31386 3.33128L4.35946 3.20968C4.38226 3.15648 4.39746 3.11088 4.42026 3.07288C5.30186 1.02848 6.28986 0.390084 8.07586 0.876484ZM13.2363 5.34528L13.2211 5.33768C12.7651 5.20848 12.3015 5.14008 11.8303 5.14008H7.07266L8.78266 1.16528L8.80546 1.11208C8.91186 1.15008 9.02586 1.20328 9.13986 1.24128L10.8195 1.94808C11.7543 2.33568 12.4079 2.73848 12.8107 3.22488C12.8791 3.31608 12.9399 3.39968 13.0007 3.49848C13.0691 3.60488 13.1223 3.71128 13.1527 3.82528C13.1831 3.89368 13.2059 3.95448 13.2211 4.02288C13.3351 4.41048 13.3427 4.85128 13.2363 5.34528ZM12.9019 6.43208C12.5599 6.33328 12.2027 6.28008 11.8303 6.28008H4.41266C3.89586 6.28008 3.40946 6.37888 2.95346 6.57648C2.28626 6.86351 1.7177 7.33959 1.31793 7.94599C0.91817 8.55239 0.704696 9.26257 0.703857 9.98888V11.4709C0.703857 11.6533 0.719057 11.8281 0.741857 12.0105C0.909057 14.4273 2.20106 15.7193 4.61786 15.8789C4.79266 15.9017 4.96746 15.9169 5.15746 15.9169H11.0855C13.8975 15.9169 15.3795 14.5793 15.5239 11.9193C15.5315 11.7749 15.5391 11.6229 15.5391 11.4709V9.98888C15.538 9.19186 15.2812 8.41621 14.8065 7.77597C14.3318 7.13573 13.6642 6.66469 12.9019 6.43208ZM10.0215 11.5013H8.69146V12.8769C8.69146 13.1885 8.43306 13.4469 8.12146 13.4469C7.80986 13.4469 7.55146 13.1885 7.55146 12.8769V11.5013H6.22146C6.07028 11.5013 5.9253 11.4412 5.81841 11.3343C5.71151 11.2274 5.65146 11.0825 5.65146 10.9313C5.65146 10.7801 5.71151 10.6351 5.81841 10.5282C5.9253 10.4213 6.07028 10.3613 6.22146 10.3613H7.55146V9.07688C7.55146 8.76528 7.80986 8.50688 8.12146 8.50688C8.43306 8.50688 8.69146 8.76528 8.69146 9.07688V10.3613H10.0215C10.1726 10.3613 10.3176 10.4213 10.4245 10.5282C10.5314 10.6351 10.5915 10.7801 10.5915 10.9313C10.5915 11.0825 10.5314 11.2274 10.4245 11.3343C10.3176 11.4412 10.1726 11.5013 10.0215 11.5013Z" fill="white" />
                              </svg>
                            </button>
                          </Link>
                        </div>
                      </div>
                      {/* <div className='depWit'>
                        <button className='Balance align-items-center d-flex mx-2 dropdown-toggle' id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8.07586 0.876484L6.24426 5.14008H4.41266C4.10866 5.14008 3.81226 5.16288 3.52346 5.22368L4.28346 3.39968L4.31386 3.33128L4.35946 3.20968C4.38226 3.15648 4.39746 3.11088 4.42026 3.07288C5.30186 1.02848 6.28986 0.390084 8.07586 0.876484ZM13.2363 5.34528L13.2211 5.33768C12.7651 5.20848 12.3015 5.14008 11.8303 5.14008H7.07266L8.78266 1.16528L8.80546 1.11208C8.91186 1.15008 9.02586 1.20328 9.13986 1.24128L10.8195 1.94808C11.7543 2.33568 12.4079 2.73848 12.8107 3.22488C12.8791 3.31608 12.9399 3.39968 13.0007 3.49848C13.0691 3.60488 13.1223 3.71128 13.1527 3.82528C13.1831 3.89368 13.2059 3.95448 13.2211 4.02288C13.3351 4.41048 13.3427 4.85128 13.2363 5.34528ZM12.9019 6.43208C12.5599 6.33328 12.2027 6.28008 11.8303 6.28008H4.41266C3.89586 6.28008 3.40946 6.37888 2.95346 6.57648C2.28626 6.86351 1.7177 7.33959 1.31793 7.94599C0.91817 8.55239 0.704696 9.26257 0.703857 9.98888V11.4709C0.703857 11.6533 0.719057 11.8281 0.741857 12.0105C0.909057 14.4273 2.20106 15.7193 4.61786 15.8789C4.79266 15.9017 4.96746 15.9169 5.15746 15.9169H11.0855C13.8975 15.9169 15.3795 14.5793 15.5239 11.9193C15.5315 11.7749 15.5391 11.6229 15.5391 11.4709V9.98888C15.538 9.19186 15.2812 8.41621 14.8065 7.77597C14.3318 7.13573 13.6642 6.66469 12.9019 6.43208ZM10.0215 11.5013H8.69146V12.8769C8.69146 13.1885 8.43306 13.4469 8.12146 13.4469C7.80986 13.4469 7.55146 13.1885 7.55146 12.8769V11.5013H6.22146C6.07028 11.5013 5.9253 11.4412 5.81841 11.3343C5.71151 11.2274 5.65146 11.0825 5.65146 10.9313C5.65146 10.7801 5.71151 10.6351 5.81841 10.5282C5.9253 10.4213 6.07028 10.3613 6.22146 10.3613H7.55146V9.07688C7.55146 8.76528 7.80986 8.50688 8.12146 8.50688C8.43306 8.50688 8.69146 8.76528 8.69146 9.07688V10.3613H10.0215C10.1726 10.3613 10.3176 10.4213 10.4245 10.5282C10.5314 10.6351 10.5915 10.7801 10.5915 10.9313C10.5915 11.0825 10.5314 11.2274 10.4245 11.3343C10.3176 11.4412 10.1726 11.5013 10.0215 11.5013Z" fill="white" />
                          </svg>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                          <li><Link className="dropdown-item" to="/deposit">Deposit</Link></li>
                          <li><Link className="dropdown-item" to="/withdrawal">Withdrawal</Link></li>
                        </ul>
                      </div> */}
                      <Link to="/my-account" style={{ textDecoration: 'none' }}>
                        <button className='profileByn'>
                          <svg width="40" height="36" viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_b_1584_7102)">
                              <mask id="path-1-inside-1_1584_7102" fill="white">
                                <path d="M0 4.90141C0 2.19444 2.19444 0 4.90141 0H31.0986C33.8056 0 36 2.19444 36 4.90141V31.0986C36 33.8056 33.8056 36 31.0986 36H4.90141C2.19444 36 0 33.8056 0 31.0986V4.90141Z" />
                              </mask>
                              <path d="M0 4.90141C0 2.19444 2.19444 0 4.90141 0H31.0986C33.8056 0 36 2.19444 36 4.90141V31.0986C36 33.8056 33.8056 36 31.0986 36H4.90141C2.19444 36 0 33.8056 0 31.0986V4.90141Z" fill="#FFB304" />
                              <path d="M-1.22535 4.90141C-1.22535 1.51769 1.51769 -1.22535 4.90141 -1.22535H31.0986C34.4823 -1.22535 37.2254 1.51769 37.2254 4.90141L34.7746 4.90141C34.7746 2.87118 33.1288 1.22535 31.0986 1.22535H4.90141C2.87118 1.22535 1.22535 2.87118 1.22535 4.90141L-1.22535 4.90141ZM37.2254 32.1732C37.2254 35.557 34.4823 38.3 31.0986 38.3H4.90141C1.51769 38.3 -1.22535 35.557 -1.22535 32.1732L1.22535 31.0986C1.22535 32.5353 2.87118 33.7 4.90141 33.7H31.0986C33.1288 33.7 34.7746 32.5353 34.7746 31.0986L37.2254 32.1732ZM4.90141 38.3C1.51769 38.3 -1.22535 35.557 -1.22535 32.1732V4.90141C-1.22535 1.51769 1.51769 -1.22535 4.90141 -1.22535L4.90141 1.22535C2.87118 1.22535 1.22535 2.87118 1.22535 4.90141V31.0986C1.22535 32.5353 2.87118 33.7 4.90141 33.7L4.90141 38.3ZM31.0986 -1.22535C34.4823 -1.22535 37.2254 1.51769 37.2254 4.90141V32.1732C37.2254 35.557 34.4823 38.3 31.0986 38.3L31.0986 33.7C33.1288 33.7 34.7746 32.5353 34.7746 31.0986V4.90141C34.7746 2.87118 33.1288 1.22535 31.0986 1.22535L31.0986 -1.22535Z" fill="url(#paint0_linear_1584_7102)" mask="url(#path-1-inside-1_1584_7102)" />
                              <path d="M11.014 6.78745C9.40801 5.58596 7.97094 5.16472 7.18881 5.00003C6.94036 5.75976 6.58662 7.2149 6.82416 9.20647C7.13461 11.8095 8.27445 13.8132 8.7939 14.6403L14.7349 11.2103C14.2784 10.3468 13.113 8.35778 11.014 6.78745Z" fill="#333940" />
                              <path d="M25.4956 6.78745C27.1016 5.58596 28.5386 5.16472 29.3208 5.00003C29.5692 5.75976 29.923 7.2149 29.6854 9.20647C29.375 11.8095 28.2351 13.8132 27.7157 14.6403L21.7747 11.2103C22.2312 10.3468 23.3966 8.35778 25.4956 6.78745Z" fill="#101214" />
                              <path d="M18.2548 10.0908H18.23C17.0595 10.107 13.2896 10.3076 9.86131 13.1193C5.60978 16.6062 5.08274 21.4854 5 22.4196L9.18223 21.7745L18.2548 26.9606L19.7828 17.4716L18.2548 10.0908Z" fill="#555A65" />
                              <path d="M18.2549 10.0908H18.2797C19.4502 10.107 23.2201 10.3076 26.6484 13.1193C30.8999 16.6063 31.427 21.4855 31.5098 22.4197L27.3275 21.7746L18.2549 26.9606V10.0908Z" fill="#333940" />
                              <path d="M18.2548 27.0284C16.8941 27.0284 15.791 27.8163 15.791 28.7883C15.791 29.7603 16.8941 30.5482 18.2548 30.5482L19.1534 28.7883L18.2548 27.0284Z" fill="#555A65" />
                              <path d="M18.2549 27.0284C19.6156 27.0284 20.7187 27.8163 20.7187 28.7883C20.7187 29.7603 19.6156 30.5482 18.2549 30.5482V27.0284Z" fill="#333940" />
                              <path d="M14.8217 23.209C16.2443 20.9361 16.449 18.5621 15.3539 17.1876C14.6371 16.2879 13.571 16.0769 13.3562 16.0344C10.7372 15.5163 7.48587 18.1555 5 22.4196C5.99467 22.4895 6.95808 22.7968 7.80954 23.3158C7.62581 23.5235 7.48947 23.7688 7.40999 24.0345C7.27803 24.4781 7.34336 24.8545 7.38513 25.0283L18.2548 28.7882L19.1534 27.269L18.2548 25.8839L14.8217 23.209Z" fill="white" />
                              <path d="M21.688 23.209C20.2654 20.9361 20.0607 18.5621 21.1558 17.1876C21.8726 16.2879 22.9387 16.0769 23.1535 16.0344C25.7725 15.5163 29.0238 18.1555 31.5097 22.4196C30.515 22.4895 29.5516 22.7968 28.7002 23.3158C28.8839 23.5235 29.0202 23.7688 29.0997 24.0345C29.2317 24.4781 29.1663 24.8545 29.1246 25.0283L18.2549 28.7882V25.8839L21.688 23.209Z" fill="#E9EDF5" />
                              <path d="M18.255 20.9537C17.7798 21.0431 16.5144 21.3466 15.4268 22.461C14.3119 23.6032 14.0673 24.8971 13.9692 25.4589C13.8427 26.1832 13.7111 26.937 14.1017 27.7612C14.2018 27.9725 14.6407 28.8306 15.6587 29.2271C16.9563 29.7324 18.1107 29.0653 18.255 28.9786L19.4869 25.5297L18.255 20.9537Z" fill="#333940" />
                              <path d="M18.2549 20.9537C18.73 21.0431 19.9955 21.3466 21.0831 22.461C22.198 23.6032 22.4425 24.8971 22.5407 25.4589C22.6671 26.1832 22.7987 26.937 22.4081 27.7612C22.308 27.9725 21.8692 28.8306 20.8512 29.2271C19.5536 29.7324 18.3992 29.0653 18.2549 28.9786V20.9537Z" fill="#101214" />
                              <path d="M16.1431 25.2929L18.2549 27.7566L19.1534 26.2255L18.2549 25.2929H16.1431Z" fill="#555A65" />
                              <path d="M20.3667 25.2929L18.2549 27.7566V25.2929H20.3667Z" fill="#333940" />
                              <path d="M12.363 20.4414C11.2817 20.1224 10.6923 18.9323 11.1183 17.8835L14.8355 19.2365C14.5004 20.2618 13.3775 20.8129 12.363 20.4414Z" fill="#555A65" />
                              <path d="M24.147 20.4414C25.2284 20.1224 25.8177 18.9323 25.3917 17.8835L21.6746 19.2365C22.0096 20.2618 23.1325 20.8129 24.147 20.4414Z" fill="#333940" />
                            </g>
                            <defs>
                              <filter id="filter0_b_1584_7102" x="-24.507" y="-24.507" width="85.0141" height="85.0141" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                <feGaussianBlur in="BackgroundImageFix" stdDeviation="12.2535" />
                                <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1584_7102" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1584_7102" result="shape" />
                              </filter>
                              <linearGradient id="paint0_linear_1584_7102" x1="35" y1="36" x2="-1.56516" y2="34.3331" gradientUnits="userSpaceOnUse">
                                <stop stopColor="white" stopOpacity="0.2" />
                                <stop offset="1" stopColor="white" stopOpacity="0.1" />
                                <stop offset="1" stopColor="white" stopOpacity="0.05" />
                              </linearGradient>
                            </defs>
                          </svg>
                        </button>
                      </Link>
                    </div>
                  )}

                {/*------------- Show Payment Screens -------------------- */}
                {/* 
        <button className='filter' onClick={handleShowFilter}>
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
            <path d="M3.83333 5.16659C3.83333 4.6143 4.28105 4.16659 4.83333 4.16659C5.38562 4.16659 5.83333 4.6143 5.83333 5.16659C5.83333 5.71887 5.38562 6.16658 4.83333 6.16658C4.28105 6.16658 3.83333 5.71887 3.83333 5.16659ZM4.83333 2.83325C3.54467 2.83325 2.5 3.87792 2.5 5.16659C2.5 6.45525 3.54467 7.49992 4.83333 7.49992C6.122 7.49992 7.16667 6.45525 7.16667 5.16659C7.16667 3.87792 6.122 2.83325 4.83333 2.83325ZM8.5 5.83325H13.8333V4.49992H8.5V5.83325ZM11.1667 11.8333C11.1667 11.281 11.6144 10.8333 12.1667 10.8333C12.7189 10.8333 13.1667 11.281 13.1667 11.8333C13.1667 12.3855 12.7189 12.8333 12.1667 12.8333C11.6144 12.8333 11.1667 12.3855 11.1667 11.8333ZM12.1667 9.49992C10.878 9.49992 9.83333 10.5446 9.83333 11.8333C9.83333 13.1219 10.878 14.1666 12.1667 14.1666C13.4553 14.1666 14.5 13.1219 14.5 11.8333C14.5 10.5446 13.4553 9.49992 12.1667 9.49992ZM3.16667 11.1666V12.4999H8.5V11.1666H3.16667Z" fill="white" />
          </svg>
          All
        </button> */}
                {/*------------- Show Payment Screens -------------------- */}

              </nav>
            </div>
          </div>
        </div>
      </section>

      <Modal show={showCurrency} onHide={handleCloseCurrency} className='selectCurrency modal-slide-up'>
        <Modal.Body>
          <div className='currencySearchBar '>
            <input type="text" name="search" placeholder='Select Currency' value={searchCurrency} onChange={handleSearchCurrency} autoComplete='off' />
            <button>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path d="M11.5264 2C16.4944 2 20.5264 6.032 20.5264 11C20.5264 15.968 16.4944 20 11.5264 20C6.55837 20 2.52637 15.968 2.52637 11C2.52637 6.032 6.55837 2 11.5264 2ZM11.5264 18C15.3939 18 18.5264 14.8675 18.5264 11C18.5264 7.1325 15.3939 4 11.5264 4C7.65887 4 4.52637 7.1325 4.52637 11C4.52637 14.8675 7.65887 18 11.5264 18ZM20.0117 18.0711L22.8401 20.8995L21.4259 22.3137L18.5975 19.4853L20.0117 18.0711Z" fill="#CCCCCC" />
              </svg>
            </button>
          </div>
          <ul className='CurrencyList'>
            {/* {currencyList.length > 0 && currencyList.map((key: any, index: number) => (
              <React.Fragment key={index}>
                {(searchCurrency === "" || key?.currency_code.toLowerCase().includes(searchCurrency.toLowerCase())) &&
                  <li className={selectedIndex === index ? 'Countryselected' : ''} key={index}>
                    <div className='d-flex align-items-center' style={{ width: '50%' }}>
                      <img src={AuthService?.baseUrlImage + 'public/storage/flags/' + key?.flag} alt={key?.currency_code} className='img-fluid' />
                      <h3>{key?.currency_code}</h3>
                    </div>
                    <h3 className='m-0' style={{ width: '50%' }}>$2573.98</h3>
                    <img src={Nocheck} alt="" className='img-fluid noSelect' />
                    <img src={Yescheck} alt="" className='img-fluid yesSelect' />
                    <div className="form-check" onClick={() => handleClickCurrency(index, key?.currency_code)}>
                      <input className="form-check-input" type="radio" name={`currency${index}`} id={`currency${index}`} value={key?.currency_code} />
                      <label className="form-check-label" htmlFor={`currency${index}`}>Cheked</label>
                    </div>
                  </li>
                }
              </React.Fragment>
            ))} */}
            {wallet.length > 0 && wallet.map((key: any, index: number) => (
              <React.Fragment key={index}>
                {(searchCurrency === "" || key?.symbol.toLowerCase().includes(searchCurrency.toLowerCase())) &&
                  <li className={selectedIndex === index ? 'Countryselected' : ''} key={index}>
                    <div className='d-flex align-items-center' style={{ width: '30%' }}>
                      <img src={AuthService?.baseUrlImage + 'public/storage/flags/' + key?.flag} alt={key?.currency_code} className='img-fluid' />
                      <h3>{key?.symbol}</h3>
                    </div>
                    <h3 className='m-0' style={{ width: '50%' }}>{key?.available_balance}</h3>
                    <img src={Nocheck} alt="" className='img-fluid noSelect' />
                    <img src={Yescheck} alt="" className='img-fluid yesSelect' />
                    <div className="form-check" onClick={() => handleClickCurrency(index, key?.symbol)}>
                      <input className="form-check-input" type="radio" name={`currency${index}`} id={`currency${index}`} value={key?.symbol} />
                      <label className="form-check-label" htmlFor={`currency${index}`}>Cheked</label>
                    </div>
                  </li>
                }
              </React.Fragment>
            ))}

          </ul>
          <button className='btn btn-primary-cc'>Wallet Settings</button>
        </Modal.Body>
      </Modal>

      {/* transactions list filters */}
      <Modal show={showfilter} onHide={handleCloseFilter} className='selectCurrency modal-slide-up'>
        <Modal.Body>
          <div className='d-flex justify-content-between align-items-center border-b-cst pt-0'>
            <h2 className='text-white m-0'>Filters</h2>
            <button className='filterCl'>Clear</button>
          </div>
          <div className='d-flex align-items-center flex-wrap border-b-cst filterBtn'>
            <button>All</button>
            <button>Deposit</button>
            <button>Withdrawal</button>
            <button>Failed</button>
            <button>Failed</button>
            <button>Processing</button>
          </div>
          <div>
            <h2 className='text-white mt-3'>Period</h2>
            <div className='d-flex align-items-center flex-wrap border-b-cst filterBtn'>
              <button>Today</button>
              <button>This Week</button>
              <button>This Month</button>
              <button>Previous Month</button>
              <button>Last Year</button>
            </div>
          </div>
          <div>
            <h2 className='text-white mt-3'>Select Period</h2>
            <div className='d-flex align-items-center justify-content-between flex-wrap border-b-cst filterBtn'>
              <div className='datePicker'>
                <input type="date" id="from" name="from" value={currentDate}
                  onChange={(e) => setCurrentDate(e.target.value)} />
              </div>
              <p className='m-0 text-white px-2'>-</p>
              <div className='datePicker'>
                <input type="date" id="to" name="to" value={currentDate}
                  onChange={(e) => setCurrentDate(e.target.value)} />
              </div>
            </div>
            {/* <RangePicker/> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default Header;